import template from './menu-selecao-contexto.html'

export default function MenuSelecaoContextoDirective() {
  return {
    replace: true,
    scope: {},
    controllerAs: 'vm',
    template: template,
    controller: MenuSelecaoContextoController,
    bindToController: true
  };
}

MenuSelecaoContextoController.$inject = [
  '$rootScope',
  '$state',
  '$q',
  'MenuSelecaoContextoService',
  'SubcontextoContextoHolderService'
];

export function MenuSelecaoContextoController(
  $rootScope,
  $state,
  $q,
  menuSelecaoContextoService,
  subcontextoContextoHolderService,
) {
  const vm = this;

  vm.entidade = undefined;
  vm.sistema = undefined;
  vm.subcontexto = undefined;
  vm.sistemas = [];
  vm.entidades = [];
  vm.subcontextos = [];

  vm.exibirMenuContexto = true;
  vm.removerExibicao = removerExibicao;
  vm.exibirSelecaoSistemas = exibirSelecaoSistemas;
  vm.exibirSelecaoSubcontexto = exibirSelecaoSubcontexto;
  vm.selecionarEntidade = selecionarEntidade;
  vm.selecionarSistema = selecionarSistema;
  vm.selecionarSubcontexto = selecionarSubcontexto;

  carregarEntidades();
  inicializarEventos();

  function carregarEntidades() {
    menuSelecaoContextoService.getEntidades().then((entidades) => {
      vm.entidades = entidades;
    });
  }

  function carregarSistemas() {
    menuSelecaoContextoService.getSistemas().then((sistemas) => {
      vm.sistemas = sistemas;
    });
  }

  function carregarSubcontextos() {
    if (!_.isEmpty(vm.subcontextos)) {
      return $q.resolve();
    }

    return menuSelecaoContextoService.getSubcontextos().then((subcontextosConfigs) => {
      if (_.isEmpty(subcontextosConfigs)) {
        return $q.reject();
      }

      vm.subcontextoConfig = subcontextosConfigs[0];
      vm.subcontextos = filterAdminOptions(vm.subcontextoConfig);
    });
  }

  function filterAdminOptions(subcontextoConfig) {
    const adminSubcontextoIdSet = new Set(
      subcontextoConfig.accesses
        .filter(access => access.admin)
        .map(access => access.subcontextId)
    );

    return subcontextoConfig.options.filter(option => adminSubcontextoIdSet.has(option.id));
  }

  function inicializarEventos() {
    $rootScope.$on('bfc:user-access:new', () => {
      carregarSistemas();
    });

    $rootScope.$on('app-context:APP_SYSTEM:new', () => {
      vm.sistema = menuSelecaoContextoService.getSistemaAtual();
      loadSystems();
    });

    $rootScope.$on('gerenciador.acessos.entidade.selecionada', (evt, data) => {
      vm.entidade = data.entidade;
    });

    $rootScope.$on('gerenciador.acessos.sistema.selecionado', (evt, data) => {
      vm.sistema = data.sistema;
    });

    $rootScope.$on('gerenciador.acessos.subcontexto.selecionado', (evt, data) => {
      carregarSubcontextos().then(() => {
        vm.subcontexto = _.find(vm.subcontextos, { id: data.subcontexto.value });
      });
    });

    $rootScope.$on('$stateChangeSuccess', (info, newState) => {
      if (newState.name === 'main.entidade') {
        resetAllContext();
        return;
      }
    });
  }

  function removerExibicao() {
    vm.exibirMenuContexto = false;
    $rootScope.$broadcast('removerExibicaoMenuContextualEmAtalho');
  }

  function exibirSelecaoSistemas() {
    return !!vm.sistema;
  }

  function exibirSelecaoSubcontexto() {
    return !!vm.subcontexto;
  }

  function selecionarEntidade(entidade) {
    resetSistemaContext();
    return menuSelecaoContextoService.selecionarEntidade(entidade);
  }

  function selecionarSistema(sistema) {
    clearSubcontextos();
    resetCurrentSubcontexto();
    return menuSelecaoContextoService.selecionarSistema(sistema);
  }

  function selecionarSubcontexto(subcontexto) {
    vm.subcontexto = subcontexto;
    return menuSelecaoContextoService.selecionarSubcontexto(subcontexto, vm.subcontextoConfig);
  }

  function resetSistemaContext() {
    vm.sistema = undefined;
    resetCurrentSubcontexto();
    clearSubcontextos();
    menuSelecaoContextoService.clearSistema();
  }

  function resetCurrentSubcontexto() {
    vm.subcontexto = undefined;
    subcontextoContextoHolderService.remove();
  }

  function clearSubcontextos() {
    vm.subcontextos = [];
  }

  function resetAllContext() {
    vm.entidade = undefined;
    resetSistemaContext();
    resetCurrentSubcontexto();
    clearSubcontextos();
  }
}
